export default __webpack_public_path__ + "static/media/yezi.03967d88.png";